var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "inspections-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _vm._l(_vm.years, function (y, i) {
          return _c("tr", { key: i }, [
            _c("td", { staticClass: "first-column" }, [
              _c(
                "button",
                {
                  staticClass: "btn blue-red-hover-text",
                  on: {
                    click: function ($event) {
                      return _vm.getByYear(y)
                    },
                  },
                },
                [_vm._v(_vm._s(y))]
              ),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right" }, [
              _vm._v(_vm._s(_vm.data[y].plan.amount)),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "left" }, [
              _vm._v("(" + _vm._s(_vm.data[y].plan.violations) + ")"),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right" }, [
              _vm._v(_vm._s(_vm.data[y].notplan.amount)),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "left" }, [
              _vm._v("(" + _vm._s(_vm.data[y].notplan.violations) + ")"),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "right" }, [
              _vm._v(
                _vm._s(_vm.data[y].plan.amount + _vm.data[y].notplan.amount)
              ),
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "left" }, [
              _vm._v(
                "(" +
                  _vm._s(
                    _vm.data[y].plan.violations + _vm.data[y].notplan.violations
                  ) +
                  ")"
              ),
            ]),
          ])
        }),
        _vm._v(" "),
        _c("tr", { staticClass: "last-row" }, [
          _c("td", { staticClass: "first-column" }, [
            _c(
              "button",
              {
                staticClass: "btn italic blue-red-hover-text",
                on: {
                  click: function ($event) {
                    return _vm.getByYear("")
                  },
                },
              },
              [_vm._v("Все годы")]
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "right" }, [
            _vm._v(_vm._s(_vm.data.total.plan.amount)),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "left" }, [
            _vm._v("(" + _vm._s(_vm.data.total.plan.violations) + ")"),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "right" }, [
            _vm._v(" " + _vm._s(_vm.data.total.notplan.amount)),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "left" }, [
            _vm._v("(" + _vm._s(_vm.data.total.notplan.violations) + ")"),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "right" }, [
            _vm._v(
              _vm._s(_vm.data.total.plan.amount + _vm.data.total.notplan.amount)
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "left" }, [
            _vm._v(
              "(" +
                _vm._s(
                  _vm.data.total.plan.violations +
                    _vm.data.total.notplan.violations
                ) +
                ")"
            ),
          ]),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Год")]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [
          _vm._v("Плановые"),
          _c("br"),
          _vm._v("(нарушения)"),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [
          _vm._v("Внеплановые"),
          _c("br"),
          _vm._v("(нарушения)"),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { colspan: "2" } }, [
          _vm._v("Всего"),
          _c("br"),
          _vm._v("(нарушения)"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }